/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getEmbedExternalView.defs.js'
export { main as default } from './getEmbedExternalView.defs.js'
